<template>
  <div class="component-button-selector" :class="computedClass">
    <div class="_button-selector-wrap">
      <div class="_result-inp-wrap" v-show="matched">
        <p class="_result-label synormal" v-if="matched">{{ matched.label }}</p>
        <div class="_result-clean" @click="handleInput(null)">
          <Close width="14px" />
        </div>
      </div>
      <Button :size="size" class="_btn-selector" skin="grey" v-show="!matched">{{ label }}</Button>
      <Select class="_component-select" :value="value" @input="handleInput">
        <Option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
      </Select>
    </div>
  </div>
</template>
<script>
import { Close } from '../../icons';
import Button from '../Button';
import { Select, Option } from 'element-ui';
export default {
  name: 'ButtonSelector',
  components: {
    Button,
    Select,
    Option,
    Close
  },
  props: {
    label: {
      type: String,
      default: '添加志愿'
    },
    value: {
      default: null
    },
    options: {
      type: Array,
      default: function() {
        return [];
      }
    },
    size: {
      type: String,
      default: 'normal'
    }
  },
  computed: {
    computedClass() {
      let ret = {};
      ret[`size-${this.size}`] = true;
      return ret;
    },
    matched() {
      return this.options.find(item => item.value === this.value);
    }
  },
  methods: {
    handleInput: function(e) {
      this.$emit('input', e);
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
